import styled from 'styled-components'

export const Form = styled.div`
  margin-top: 32px;
  width: 80%;
  display: flex;
  align-items: center;
  gap: 57px;
  margin-bottom: 32px;
  flex-shrink: 0;
`
